import React, { useEffect, useState, useRef } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Clients.css';

const ClientsPage = () => {
  const [activeTab, setActiveTab] = useState('clients');
  const sliderRef = useRef(null);

  const tabList = [
    { key: 'clients', label: 'Clients' },
    { key: 'testimonials', label: 'Testimonials' },
  ];

const missingLogos = [23, 28];
const logoList = Array.from({ length: 71 }, (_, i) => {
  const num = i + 1;
  if (missingLogos.includes(num)) return null; // skip missing logos
  const ext = [4, 5, 6, 7, 10, 14, 16, 21, 24, 37, 45, 48, 64, 66, 70].includes(num)
    ? 'png'
    : 'jpg';
  return `/img/client-logos/l${num}.${ext}`;
}).filter(Boolean); // remove nulls

  const testimonials = [
    {
      type: 'video',
      src: 'https://www.youtube.com/embed/5Lkds1a1D70',
      name: 'Raghav Bahl - Quint',
    },
    {
      quote: '"Association with SmartVizX has helped us hugely..."',
      name: 'Ankur Maheshwari, Developer Group, The Economic Times',
    },
    {
      type: 'video',
      src: 'https://www.youtube.com/embed/Mx6H8uVLbxQ',
      name: 'Ritu Kapur - Quint',
    },
    {
      quote: '"I am super excited about what SmartVizX is developing..."',
      name: 'Ashwin Chadha, Sotheby’s International Realty',
    },
    {
      quote: '"Adoption of a VR solution from SmartVizX has helped us..."',
      name: 'Tushar Mehendale, ElectroMech',
    },
    {
      quote: '"I was amazed to see how they\'ve set out to change the game..."',
      name: 'Chakrit Vorachacreyanan, Rockworth',
    },
  ];

  const renderTestimonials = () => (
    <div className="card-shell">
      {testimonials.map((item, i) => (
        <div className="card" key={i}>
          {item.type === 'video' ? (
            <iframe src={item.src} allowFullScreen title={`testimonial-${i}`} />
          ) : (
            <h3>{item.quote}</h3>
          )}
          <h4 className="text-center"><span>{item.name}</span></h4>
        </div>
      ))}
    </div>
  );


const renderLogoSlider = () => (
  <div className="logo-slider-container" ref={sliderRef}>
    <div className="logo-track">
      {[...logoList, ...logoList].map((logo, idx) => (
        <div className="logo-card" key={idx}>
          <img src={logo} alt={`Client ${idx + 1}`} />
        </div>
      ))}
    </div>
  </div>
);


useEffect(() => {
  const track = document.querySelector('.logo-track');
  const cards = document.querySelectorAll('.logo-card');

  if (!track || cards.length === 0) return;

  const applySliderSpeed = () => {
    const singleSetWidth = track.scrollWidth / 2; // because logos duplicated
    const viewportWidth = window.innerWidth;
    const pixelsPerSecond = viewportWidth <= 480
      ? 22
      : viewportWidth <= 768
        ? 28
        : 56;

    const duration = singleSetWidth / pixelsPerSecond;
    track.style.animation = `scrollInfinite ${duration}s linear infinite`;
  };

  applySliderSpeed();

  // ===== CONTINUOUS CENTER-WEIGHTED LOGO REVEAL =====
  const updateLogoFocus = () => {
    const centerX = window.innerWidth / 2;
    const falloff = Math.max(window.innerWidth * 0.24, 190);

    cards.forEach(card => {
      const box = card.getBoundingClientRect();
      const cardCenter = box.left + box.width / 2;
      const dist = Math.abs(centerX - cardCenter);
      const focus = Math.max(0, 1 - dist / falloff);

      card.style.setProperty('--focus', focus.toFixed(3));
    });
  };

  let frameId;
  const loop = () => {
    updateLogoFocus();
    frameId = requestAnimationFrame(loop);
  };

  frameId = requestAnimationFrame(loop);
  window.addEventListener('resize', applySliderSpeed);

  return () => {
    cancelAnimationFrame(frameId);
    window.removeEventListener('resize', applySliderSpeed);
    cards.forEach((card) => card.style.removeProperty('--focus'));
  };

}, []);
  return (
    <>
      <Navbar />
<main className="clients-container">
          <h2 className="portfolio-header header-shadow text-center">Our Clients</h2>

        <ul className="pd-tabs">
          {tabList.map(tab => (
            <li
              key={tab.key}
              className={activeTab === tab.key ? 'active' : ''}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </li>
          ))}
        </ul>

        <section className="pd-content">
          <div className="clients-wrapper">
            {activeTab === 'clients' && renderLogoSlider()}
            {activeTab === 'testimonials' && renderTestimonials()}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ClientsPage;
